import axios from '../axios';

const glSettingsApi = {
  get: () => axios.get('/GlSettings'),
  update: (data) => axios.post('/GlSettings', data),
};

export default glSettingsApi;
